/**
 * Used for the home page sectional navigation
 */
export const HOME_SECTION_IDS = {
  experience: 'experience',
  projects: 'projects',
  about: 'about',
  courses: 'courses',
  references: 'references',
};

/**
 * Used for the home page sectional navigation
 */
export const EXPERIENCE_SECTION_IDS = {
  experience: 'experience',
  references: 'references',
};
